export default __webpack_public_path__ + "static/media/KOD0088-min.4d5d55e1.webp";